import { Component, ElementRef, Input, Output, EventEmitter } from '@angular/core';
// import { Map, MapView, Extent, SpatialReference, Point } from 'esri-mods';

import MapView = require('esri/views/MapView');

import { MapService } from './map.service';
import { EventsService } from '../../shared/Events.service';

@Component({
    selector: 'map-info',
    // templateUrl: 'app/information/map/map.component.html',
    template:'<div id="viewDiv"><ng-content></ng-content></div>'
    // providers: [MapService] 
})
export class MapComponent {
    @Input() zoom: number; 
    // @Input() centerX: number;
    // @Input() centerY: number;

    @Output() viewCreated = new EventEmitter();

    view: MapView = null;
    map: any;
    options: Object;
    
    constructor(private elRef: ElementRef, private _eventsService: EventsService, private _mapService: MapService) { 
        
        
        
    }

    
    ngOnInit() {

        this.view = new MapView({
            container: this.elRef.nativeElement.firstChild,
            map: this._mapService.map,
            zoom: this.zoom
            // center: [this.centerLng, this.centerLat],
            // rotation: this.rotation
        });

        
        //map is loaded, then do some stuff
        this.view.then(function (view) {

            this.viewCreated.next(view);
        }.bind(this));
        
        this.view.on("click", function(evt){
            // evt is the event object returned after the event fires

            // Prints the map coordinates of the clicked location
             console.log(evt.mapPoint.x,evt.mapPoint.y );
        });
    }

    // destroy map
    ngOnDestroy() {
        if (this.map) {
            this.map.destroy();
        }
    }

}


// WEBPACK FOOTER //
// ./app/information/map/map.component.ts